import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareAssetNameVisibilityMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  showAssetNameInReelLayout?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareAssetNameVisibilityMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, showAssetNameInReelLayout: boolean } | { __typename?: 'CollectionShare', id: string, showAssetNameInReelLayout: boolean } | null } | null };


export const UpdateShareAssetNameVisibility = /*#__PURE__*/ gql`
    mutation UpdateShareAssetNameVisibility($shareId: ID!, $showAssetNameInReelLayout: Boolean) {
  updateShare(
    input: {shareId: $shareId, settings: {showAssetNameInReelLayout: $showAssetNameInReelLayout}}
  ) {
    share {
      id
      showAssetNameInReelLayout
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareAssetNameVisibilityMutation, UpdateShareAssetNameVisibilityMutationVariables>;

          

          export const useUpdateShareAssetNameVisibilityMutation = (options?:MutationHookOptions<UpdateShareAssetNameVisibilityMutation, UpdateShareAssetNameVisibilityMutationVariables>) => useMutation(UpdateShareAssetNameVisibility, options);
          

          export type UpdateShareAssetNameVisibilityMutationOptions = MutationHookOptions<UpdateShareAssetNameVisibilityMutation, UpdateShareAssetNameVisibilityMutationVariables>;

          

          export type UpdateShareAssetNameVisibilityMutationResult = ReturnType<typeof useUpdateShareAssetNameVisibilityMutation>[1];

          
